import { Structure } from "./structure";
import { BufferSourceConverter, Convert } from "pvtsutils";
export var SignatureType;
(function (SignatureType) {
    SignatureType[SignatureType["certificateTimestamp"] = 0] = "certificateTimestamp";
    SignatureType[SignatureType["treeHash"] = 1] = "treeHash";
})(SignatureType || (SignatureType = {}));
export var HashAlgorithm;
(function (HashAlgorithm) {
    HashAlgorithm[HashAlgorithm["none"] = 0] = "none";
    HashAlgorithm[HashAlgorithm["md5"] = 1] = "md5";
    HashAlgorithm[HashAlgorithm["sha1"] = 2] = "sha1";
    HashAlgorithm[HashAlgorithm["sha224"] = 3] = "sha224";
    HashAlgorithm[HashAlgorithm["sha256"] = 4] = "sha256";
    HashAlgorithm[HashAlgorithm["sha384"] = 5] = "sha384";
    HashAlgorithm[HashAlgorithm["sha512"] = 6] = "sha512";
})(HashAlgorithm || (HashAlgorithm = {}));
export var SignatureAlgorithm;
(function (SignatureAlgorithm) {
    SignatureAlgorithm[SignatureAlgorithm["anonymous"] = 0] = "anonymous";
    SignatureAlgorithm[SignatureAlgorithm["rsa"] = 1] = "rsa";
    SignatureAlgorithm[SignatureAlgorithm["dsa"] = 2] = "dsa";
    SignatureAlgorithm[SignatureAlgorithm["ecdsa"] = 3] = "ecdsa";
})(SignatureAlgorithm || (SignatureAlgorithm = {}));
export class SignedCertificateTimestamp extends Structure {
    constructor(stream) {
        super();
        this.version = 0;
        this.logId = new ArrayBuffer(32);
        this.timestamp = new Date();
        this.extensions = new ArrayBuffer(0);
        this.hashAlgorithm = 0;
        this.signatureAlgorithm = 0;
        this.signature = new ArrayBuffer(0);
        if (stream) {
            this.parse(stream);
        }
    }
    parse(stream) {
        this.version = stream.readByte();
        stream.read(2);
        this.logId = BufferSourceConverter.toArrayBuffer(stream.read(32));
        this.timestamp = new Date(stream.readNumber(8));
        const extLen = stream.readNumber(2);
        this.extensions = stream.read(extLen).buffer;
        this.hashAlgorithm = stream.readByte();
        this.signatureAlgorithm = stream.readByte();
        this.signature = stream.read(stream.readNumber(2)).buffer;
    }
    toJSON() {
        return {
            version: this.version,
            logId: Convert.ToHex(this.logId),
            timestamp: this.timestamp,
            extensions: Convert.ToBase64(this.extensions),
            hashAlgorithm: HashAlgorithm[this.hashAlgorithm] || "undefined",
            signatureAlgorithm: SignatureAlgorithm[this.signatureAlgorithm] || "undefined",
            signature: Convert.ToBase64(this.signature),
        };
    }
}
